const { REACT_APP_CONTEXT_PATH } = process.env;

const selectBranchByBrandApi = (brandId) => {
  return {
    apiUrl: REACT_APP_CONTEXT_PATH + `/branch/available/${brandId}`,
  };
};

export default selectBranchByBrandApi;
